import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=66ae9a55&scoped=true"
import script from "./_base-button.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-button.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-button.vue?vue&type=style&index=0&id=66ae9a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae9a55",
  null
  
)

export default component.exports